/*
    generate by magix-combine@3.6.4: https://github.com/thx/magix-combine
    author: kooboy_li@163.com
    loader: webpack
 */


Magix.applyStyle("xf2a",".clearfix:after,.clearfix:before{display:table;content:\"\"}.clearfix:after{clear:both}.inline-block{display:inline-block;*display:inline;*zoom:1}.topsearch{height:90px;margin-bottom:20px}.ai-topsearch{font:12px/1.5 tahoma,microsoft yahei,\\\\5FAE\\8F6F\\96C5\\9ED1}.ai-topsearch a{color:#333;text-decoration:none}.ai-topsearch a:hover{color:#e22c37;text-decoration:none}.ai-topsearch .mainNav .red a{color:#ef470f}.ai-topsearch{-webkit-transition:all .3s;transition:all .3s;top:-60px}.con-wrap{width:990px;_width:990px;margin:0 auto;overflow:hidden}#site-nav{border-bottom:1px solid #eaeaea}#site-nav a{color:#999}.ai-topsearch{overflow:hidden;background:#fff}.ai-topsearch .search-wrap{float:left;width:100%}.ai-topsearch .search{margin-left:278px;margin-right:95px}.ai-topsearch .search .search-border{border:2px solid #ff4200;border-right:0;height:34px;margin-top:25px;position:relative}.ai-topsearch .search .btn-arrow{position:absolute;right:0;bottom:-10px;width:15px;height:7px;background:url(//img.alicdn.com/tps/i1/T1e3YIFchfXXajgF6X-15-7.png)}.ai-topsearch .search .label{float:left;height:34px;line-height:34px;width:75px;border-right:1px solid #efefef;text-align:center;background:#f6f6f6}.ai-topsearch .search .text-wrap{display:block;overflow:hidden;padding:6px 10px 5px;padding-right:110px;_width:318px}.ai-topsearch .search .text{height:23px;line-height:23px;font-size:14px;border:0 none;width:100%;outline:0}.ai-topsearch .search .txt-focus{background:0}.ai-topsearch .search .submit{width:95px;height:34px;border:0 solid #ff4200;position:absolute;top:0;right:0;background-color:#ff4200;color:#fff;font-size:16px}.ai-topsearch .search .search-links{padding:5px 0 0}.ai-topsearch .search .search-links a{margin-right:10px;color:#666}.ai-topsearch .ai-logo{width:213px;height:90px;float:left;margin-left:-100%;_display:inline}.ai-topsearch .ai-logo .logo{float:left;display:block;width:213px;height:73px;margin:25px 0 0;background:url(//img.alicdn.com/tps/TB1YZkPLpXXXXbzXXXXXXXXXXXX-213-57.png) no-repeat 0 0}.ai-topsearch .mainNav{overflow:hidden;font-size:12px;float:left;width:540px;height:27px;_margin-left:40px}.ai-topsearch .mainNav li{float:left;border-right:1px solid #fff;margin-right:10px;margin-top:10px;line-height:10px;height:12px;*height:14px;*vertical-align:middle;*line-height:16px}.ai-topsearch .mainNav li:last-child{border:none}.fixed .ai-topsearch{position:fixed;top:0;width:100%;height:60px;background:#fff;-webkit-box-shadow:0 0 4px 0 #eaeaea;box-shadow:0 0 4px 0 #eaeaea;z-index:1000}.fixed .ai-topsearch .ai-logo,.fixed .ai-topsearch .search-wrap{height:60px}.fixed .ai-topsearch .ai-logo .logo{margin-top:-3px;-webkit-transform:scale(.8);transform:scale(.8)}.fixed .ai-topsearch .search .search-border{margin-top:10px}.fixed .ai-topsearch .search .text-wrap{background:#fff}.fixed .ai-topsearch .mainNav,.fixed .ai-topsearch .search .search-links{display:none}.page-tmall .ai-topsearch .ai-logo .logo{background:url(//img.alicdn.com/tfs/TB1BI8jOVXXXXXVaFXXXXXXXXXX-111-26.png) no-repeat 50% 50%}.page-tmall .ai-topsearch .search .search-border{border-color:#c40000}.page-tmall .ai-topsearch .search .submit{background-color:#c40000}.page-tmall .fixed .ai-topsearch .ai-logo .logo{margin-top:-7px;-webkit-transform:scale(1);transform:scale(1)}#body1190 #J_SiteNav .site-nav-bd,#body1190 .ai-topsearch .con-wrap{width:1190px}#body1190 .ai-topsearch .mainNav{width:650px}#body1350 #J_SiteNav .site-nav-bd,#body1350 .ai-topsearch .con-wrap{width:1350px}#body1350 .ai-topsearch .mainNav{width:750px}@media screen and (min-width:1190px) and (max-width:1349px){#J_SiteNav .site-nav-bd,.ai-topsearch .con-wrap{width:1190px}.ai-topsearch .mainNav{width:700px}#sn-bd{width:1190px!important}}@media screen and (min-width:1350px){#J_SiteNav .site-nav-bd,.ai-topsearch .con-wrap{width:1350px}.ai-topsearch .mainNav{width:850px}#sn-bd{width:1350px!important}}.ks-popupmenu{position:absolute;left:-9999px;top:-9999px;background:#fff;z-index:1000;border:1px solid #e6e6e6}.ks-popupmenu .ks-menu-item-hover{background:#eee}.ks-popupmenu .ks-menu-item-hover .search-menu-list-item .search-menu-list-item-title .atbfont{float:right;margin-right:8px}.ks-popupmenu .search-menu-list-item{padding:5px 10px;color:#333;cursor:pointer;overflow:hidden}.ks-popupmenu .search-menu-list-item .search-menu-list-item-title{display:block;width:50%;height:18px;overflow:hidden}.ks-popupmenu .search-menu-list-item .search-menu-list-item-title .atbfont{color:#666;vertical-align:1px;margin-left:5px}.ks-popupmenu .search-tags-wrap{position:absolute;right:0;width:50%;top:0;height:100%}.ks-popupmenu .search-tags-wrap .search-tags-group{display:none;border-left:1px solid #e6e6e6;height:100%;overflow:hidden;background:#f8f8f8;padding:0 18px}.footer-toy,.ks-popupmenu .search-tags-wrap .search-tags-group-show{display:block}.ks-popupmenu .search-tags-wrap .search-tags-group h1{padding:32px 4px 10px 0;margin:0;font-size:12px;color:#666}.ks-popupmenu .search-tags-wrap .search-tags-group .search-tags-list{margin-bottom:20px}.ks-popupmenu .search-tags-wrap .search-tags-group .search-tags-list li{float:left;white-space:nowrap;margin-left:-1px;margin-top:-1px}.ks-popupmenu .search-tags-wrap .search-tags-group .search-tags-list li a{padding:5px 8px;width:50px;text-align:center;border:1px solid #cdcdcd;display:block;background-color:#fff;color:#777;text-decoration:none}.ks-popupmenu .search-tags-wrap .search-tags-group .search-tags-list li .hot,.ks-popupmenu .search-tags-wrap .search-tags-group .search-tags-list li a:hover{color:#ff5a00}");

var searchData = require('./mock.js');

module.exports = Magix.View.extend({
    tmpl: {"html":"<div mx-guid=\"g0\u001f\" id=\"J_topsearch\" class=\"topsearch\" data-spm=\"199828735011\" data-fixtop=\"<%= $$.fixtop%>\"><div class=\"ai-topsearch\"><div class=\"con-wrap clearfix\"><div class=\"search-wrap\"><div class=\"search\"><div class=\"search-border clearfix\" id=\"J_searchbox\"><form action=\"#\" id=\"J_searchForm\"><span class=\"text-wrap\"><input class=\"text ks-combobox-input\" placeholder=\"请输入要搜索的词\" id=\"q\" name=\"keyword\" accesskey=\"s\" autocomplete=\"off\" x-webkit-speech=\"\" x-webkit-grammar=\"builtin:translate\"></span><input type=\"hidden\" name=\"page\" value=\"0\"> <input type=\"submit\" class=\"submit\" value=\"搜索\" data-spm-click=\"gostr=/zz;locaid=dsearch\"></form></div><ul mx-guid=\"g1\u001f\" class=\"mainNav J_proxy_textlink\" data-pid=\"<%= $$.textlinkpid%>\" data-feload=\"1\"></ul></div></div><div class=\"ai-logo\"><span class=\"logo\" title=\"淘宝热卖\"></span></div></div></div></div>","subs":[{"keys":["fixtop"],"path":"div[mx-guid=\"g0\u001f\"]","attr":"data-fixtop=\"<%= $$.fixtop%>\"","attrs":[{"n":"data-fixtop"}]},{"keys":["textlinkpid"],"path":"ul[mx-guid=\"g1\u001f\"]","attr":"data-pid=\"<%= $$.textlinkpid%>\"","attrs":[{"n":"data-pid"}]}]},
    ctor: function ctor(opt) {
        this.opt = $.extend(true, opt, {
            S: KISSY,
            ComboBox: null,
            XTemplate: null
        });
    },
    initSearchBox: function initSearchBox() {
        var S = this.opt.S,
            ComboBox = this.opt.ComboBox,
            XTemplate = this.opt.XTemplate;

        return searchBox = {
            init: function init() {
                var self = this;
                self._bindSuggest();
            },
            startSearch: function startSearch(word) {
                var self = this,
                    formNode = S.one('#J_searchForm');

                if (word === undefined || word === '') {
                    return false;
                }

                formNode.one('.text').val(word);
                formNode.fire('submit');
            },
            _handleHoverItem: function _handleHoverItem(node) {
                var self = this,
                    index = node.attr('data-index'),
                    dstTagNode = S.one('#J_tag_group_' + index);

                S.all('.search-tags-group').removeClass('search-tags-group-show');

                if (index && dstTagNode) {
                    self.currentTagTitle = node.attr('data-title');
                    dstTagNode.one('.right-title').html(self.currentTagTitle);
                    dstTagNode.addClass('search-tags-group-show');
                }
            },
            _bindSuggest: function _bindSuggest() {
                var self = this,
                    rightTagTmpl = '<div class="search-tags-wrap">' + '{{#each magics}}' + '<div id="J_tag_group_{{index}}" class="search-tags-group">' + '<h1 class="right-title">{{searchWords}}</h1>' + '{{#each data}}' + '<ul class="search-tags-list clearfix">' + '{{#each this}}' + '<li><a href="#" class="search-tags-word">{{title}}</a></li>' + '{{/each}}' + '</ul>' + '{{/each}}' + '</div>' + '{{/each}}' + '</div>';
                S.one(document).delegate('mouseenter', '.ks-menuitem', function (e) {
                    self.inTagWrap = false;
                    S.one(e.currentTarget).siblings().removeClass('ks-menu-item-hover');
                    S.one(e.currentTarget).addClass('ks-menu-item-hover');
                });

                S.one(document).delegate('mouseenter', '.search-tags-wrap', function (e) {
                    self.inTagWrap = true;
                });

                S.one(document).delegate('mouseenter', '.search-menu-list-item', function (e) {
                    self._handleHoverItem(S.one(e.currentTarget));
                });

                S.one(document).delegate('mouseleave', '.ks-menuitem', function (e) {
                    S.later(function () {
                        !self.inTagWrap && S.one(e.currentTarget).removeClass('ks-menu-item-hover');
                    }, 100);
                });

                S.one(document).delegate('click', '#q', function (e) {
                    if (!self.basicComboBox) return;
                    var value = S.one(e.currentTarget).val();
                    value && self.basicComboBox.sendRequest(value);
                });

                S.one(document).delegate('click', '.search-tags-word', function (e) {
                    var word = S.one(e.currentTarget).html();

                    word = self.currentTagTitle.replace(/<[^>]+>/g, '') + ' ' + word;
                    self.startSearch(word);
                });
                S.one('#J_searchForm').on('submit', function (e) {
                    var form = S.one(e.currentTarget);
                    var node = form.one('.text');
                    //node.val(encodeURIComponent(node.val()))
                    if (/[<>]/.test(node.val())) {
                        //判断搜索框有没有特殊字符，有的话进行替换去掉。
                        node.val(node.val().replace(/<[^>]+>/g, '').replace(/[<>]/g, ''));
                    }
                });
                function _injectTagGroup(query, magics) {
                    var str = new XTemplate(rightTagTmpl).render({
                        magics: magics,
                        searchWords: query
                    });

                    if (!self.popMenu) {
                        self.popMenu = S.one('.ks-popupmenu');
                    }

                    if (self.popMenu) {
                        self.popMenu.one('.search-tags-wrap') && self.popMenu.one('.search-tags-wrap').remove();
                        self.popMenu.append(str);
                    }
                }

                self.basicComboBox = new ComboBox({
                    srcNode: S.one('#J_searchbox'),
                    input: S.one('#J_searchForm').one(".text"),
                    hasTrigger: false,
                    dataSource: new ComboBox.RemoteDataSource({
                        xhrCfg: {
                            url: '//suggest.taobao.com/sug?code=utf-8&area=c2c',
                            dataType: 'jsonp',
                            data: {
                                code: 'utf-8'
                            }
                        },
                        paramName: 'q',
                        cache: false,
                        parse: function parse(query, results) {
                            var list = results.result,
                                magics = results.magic,
                                filterMagics = [];

                            S.each(magics, function (m) {
                                //剔除掉除tag_group的其他类型的词
                                if (m.type == 'tag_group') {
                                    filterMagics.push(m);
                                    //返回的标识是从1开始的，所以要减一；
                                    list[parseInt(m.index) - 1].push(true);
                                }
                            });
                            S.later(function () {
                                //S.one('.ks-popupmenu').css('top',(S.one('.search-border').offset().top+39)+'px');
                                _injectTagGroup(query, filterMagics);
                            }, 300);

                            return list;
                        }
                    }),
                    format: function format(query, results) {
                        var ret = [],
                            tmpl = '<div class="search-menu-list-item" data-title="{{text}}" data-index="{{index}}">' + '<span class="search-menu-list-item-title">{{{text}}}{{#hasTag}}<i class="atbfont">></i>{{/hasTag}}</span>' + '</div>',
                            queryReg = new RegExp('^' + query);

                        S.each(results, function (re, index) {
                            //发现主搜返回的数据，有时会有特殊标记，所以这边需要处理一下。
                            re[0] = re[0].replace(/<[^>]+>/g, '');

                            ret.push({
                                textContent: re[0],
                                content: new XTemplate(tmpl).render({
                                    //是汉字，并且以query开头需要做特殊处理
                                    text: queryReg.test(re[0]) ? query + '<b>' + re[0].replace(queryReg, '') + '</b>' : re[0],
                                    count: re[1],
                                    hasTag: re[2],
                                    index: index + 1
                                })
                            });
                        });

                        return ret;
                    }
                });

                self.basicComboBox.render();

                self.basicComboBox.on('click', function (e) {
                    self.startSearch(e.target.get('value')[0]);
                });
            },
            inTagWrap: false
        };
    },
    renderSearchBox: function renderSearchBox() {
        var S = this.opt.S;
        var $ = S.all;

        //搜索框聚焦
        S.one('#q').on('keyup', function (e) {
            var val = $(e.target).val();
            if (val.length == '') {
                $(e.target).removeClass('txt-focus');
            } else {
                $(e.target).addClass('txt-focus');
            }
        });

        // navigation links' parameters setup
        var DEFAULT_REFPID = 'mm_14507511_3485205_11375261';
        var queryString = location.search.length > 0 ? location.search.substring(1) : "";
        var queryArgs = S.unparam(queryString);
        var pidforLogo = queryArgs.pid || queryArgs.refpid || '';
        delete queryArgs.tab;
        delete queryArgs.buckid;

        S.each(queryArgs, function (val, key) {
            if (S.isArray(val)) queryArgs[key] = val[0];
        });

        if (queryArgs.refpid && queryArgs.pid) delete queryArgs.pid;
        if (queryArgs.pid) {
            queryArgs.refpid = queryArgs.pid || '';
            delete queryArgs.pid;
        }

        // search box parameter setup
        // 透传参数
        var transmitParam = {
            "refpid": queryArgs.refpid || queryArgs.pid || DEFAULT_REFPID,
            "buckid": queryArgs.buckid || '',
            "b": queryArgs.b || '',
            "clk1": queryArgs.clk1 || ''
        };
        S.each(transmitParam, function (val, k) {
            if (val === "") {
                delete transmitParam[k];
            }
        });

        var transmitParamInput = [];
        S.each(transmitParam, function (val, k) {
            var input = S.DOM.create('<input>', {
                type: 'hidden',
                name: k,
                value: val
            });
            transmitParamInput.push(input);
        });
        var searchForm = S.one('#J_searchForm');
        searchForm.attr('target', '_blank').attr('action', location.pathname).prepend(transmitParamInput);

        // 判断搜索下的文字链, 为了透传 clk1, 代理文字链，
        S.Event.delegate(".J_proxy_textlink", "click", "a", function (e) {
            var a = S.one(e.currentTarget);
            var param = S.clone(transmitParam);
            param.keyword = a.html();
            if (a.attr("data-spm-anchor-id")) {
                param.spm = a.attr("data-spm-anchor-id");
            }
            if (a.parent(".J_proxy_textlink").attr("data-linkpid")) {
                param["linkpid"] = a.parent(".J_proxy_textlink").attr("data-linkpid");
            }
            a.attr("href", location.pathname + "?" + S.param(param));
        });

        setTimeout(function () {
            this.fixTop();
        }.bind(this), 500);
        this.loadTextLink(transmitParam.refpid);
        //搜索框默认选值
        if (window._SEARCHKEYWORDS && window._SEARCHKEYWORDS != 'undefined') {
            S.one('#q') && S.one('#q').addClass('txt-focus').val(decodeURIComponent(window._SEARCHKEYWORDS));
            S.one('#qSupply') && S.one('#qSupply').addClass('txt-focus').val(decodeURIComponent(window._SEARCHKEYWORDS));
        }
    },
    loadTextLink: function loadTextLink(refpid) {
        var S = this.opt.S;
        var DOM = S.DOM;
        var nav = S.one('.mainNav');
        var pid = nav && nav.attr("data-pid") || '430709_1007';

        if (!nav.attr("data-feload")) {
            return;
        }

        S.ajax({
            url: '//textlink.simba.taobao.com/lk?pid=' + pid + '&refpid=' + refpid,
            data: {},
            dataType: 'jsonp',
            success: function success(d) {
                showCategory(d);
            }
        });

        function showCategory(d) {
            var categories = d.data,
                itemLists = [];

            S.each(categories, function (thisItem, idx) {
                if (idx > 15) {
                    return;
                }
                var li = idx <= 2 ? DOM.create('<li class="red">') : DOM.create('<li>');
                var a = DOM.create('<a>', {
                    href: thisItem[1],
                    text: thisItem[0],
                    'class': 'mainNavItem',
                    target: '_blank'
                });
                DOM.append(a, li);
                itemLists.push(li);
            });
            nav.append(itemLists);
        };
    },
    fixTop: function fixTop() {
        // 判断是否搜索置顶
        var S = this.opt.S;
        var topsearch = S.one("#J_topsearch");
        var items = S.one('#searchResult') || S.one('#items');
        if (topsearch.attr("data-fixtop") && topsearch.attr("data-fixtop") == 'true' && items) {
            var search_fixed = false;
            S.one(window).on("scroll", function () {
                var position = S.DOM.scrollTop(),
                    top = items.offset().top;
                if (position >= top) {
                    if (!search_fixed) {
                        search_fixed = true;
                        topsearch.addClass('fixed');
                    }
                } else {
                    if (search_fixed) {
                        search_fixed = false;
                        topsearch.removeClass('fixed');
                    }
                }
            });
        }
    },
    render: function render() {
        var self = this;
        KISSY.use("combobox,xtemplate,event", function (S, ComboBox, XTemplate) {
            self.opt.ComboBox = ComboBox;
            self.opt.XTemplate = XTemplate;

            self.updater.set({
                root: window.root,
                textlinkpid: self.opt.textlinkpid,
                fixtop: self.opt.fixtop || "true"
            }).digest();
            self.initSearchBox().init();
            self.renderSearchBox();
        });
    }
});


//////////////////
// WEBPACK FOOTER
// ./app/views/searchheader/index.js
// module id = 7
// module chunks = 1 2